import { render, staticRenderFns } from "./EventCardGridLayout.vue?vue&type=template&id=1ffd2abc&scoped=true"
import script from "./EventCardGridLayout.vue?vue&type=script&lang=js"
export * from "./EventCardGridLayout.vue?vue&type=script&lang=js"
import style0 from "./EventCardGridLayout.vue?vue&type=style&index=0&id=1ffd2abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd2abc",
  null
  
)

export default component.exports